import * as React from 'react';
import { Page } from '../page';
import {TitledBlock} from '../../components/blocks/titledBlock/titledBlock';
import { NoticeText, StageBlock, Title, TypeWrap, TypeBlock, TypeIcon,
  TypeName, TitleInput, DetailsTextArea, SubmitButtonWrap } from './newTicket.styles';
import { Button } from '../../components/buttons/button';
import { Link } from 'react-router-dom';

interface State {
  stage: number;
}

export class NewTicketPage extends React.Component<{}, State> {
  constructor(props: {}) {
    super(props);

    this.state = {
      stage: 1
    };
  }

  public render() {
    return (
      <Page title='New Ticket' tabNavigation={true}>
        <TitledBlock title='New Maintenance Request'>
          <NoticeText>Answer the questions below to submit your request</NoticeText>
        </TitledBlock>

        {this.state.stage === 1 && this.renderFirstStage()}
        {this.state.stage === 2 && this.renderSecondStage()}
      </Page>
    );
  }

  public setStage(stage: number) {
    this.setState({stage});
  }

  public renderFirstStage(): JSX.Element {
    return (
      <StageBlock>
        <Title>1. What type of problem are you having?</Title>
        <TypeWrap>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/drop.svg')}/>
            <TypeName>Plumbing</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/electricity.svg')}/>
            <TypeName>Electric</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/appliances.svg')}/>
            <TypeName>Appliances</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/heatair.svg')}/>
            <TypeName>Heat/Air</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/keys.svg')}/>
            <TypeName>Locks & Key</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/pest.svg')}/>
            <TypeName>Pest</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => this.setStage(2)}>
            <TypeIcon icon={require('../../../assets/icons/home.svg')}/>
            <TypeName>Other</TypeName>
          </TypeBlock>
        </TypeWrap>
      </StageBlock>
    );
  }

  public renderSecondStage(): JSX.Element {
    return (
      <StageBlock>
        <Title>2. Give us a brief description of the problem:</Title>
        <TitleInput type={'text'} placeholder={'Request Title'} />
        <Title>3. Additional details: (the more the better)</Title>
        <NoticeText>Request details</NoticeText>
        <DetailsTextArea />
        <NoticeText>Response here</NoticeText>
        <TypeWrap>
          <TypeBlock onClick={() => alert('Add photo')}>
            <TypeIcon icon={require('../../../assets/icons/camera.svg')}/>
            <TypeName>Add photo</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => alert('Add video')}>
            <TypeIcon icon={require('../../../assets/icons/video.svg')}/>
            <TypeName>Add Video</TypeName>
          </TypeBlock>
          <TypeBlock onClick={() => alert('Attach file')}>
            <TypeIcon icon={require('../../../assets/icons/attach.svg')}/>
            <TypeName>Attach file</TypeName>
          </TypeBlock>
        </TypeWrap>
        <SubmitButtonWrap>
          <Link to='/submit_confirmation'>
            <Button>SUBMIT</Button>
          </Link>
        </SubmitButtonWrap>
      </StageBlock>
    );
  }
}
